import _ from 'lodash';
import { FTProcess } from '@/models/FTProcess';
import { weightToLength, initProcess, ProcessConfig, ConversionResults, ParsedVariables } from './index'
import { ConversionDetails } from '@/models/ConversionDetails';
import { convertStep } from './CConvertStep';
import { FTProcessRow } from '@/models/FTProcessRow';

export function loadConfig({ processRow }: ParsedVariables): ProcessConfig {
  return {
    settings: {
      doubleLamination: {
        type: 'checkbox',
        name: 'Double Lamination',
      }
    },
    inputs: {
      goods: [
        {
          goodsType: 'front-rm',
          goodsFilter: {
            type: ['MRM']
          },
          multiple: false,
          params: [
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        },
        {
          goodsType: 'lamination',
          goodsFilter: {
            form: ['roll']
          },
          multiple: false,
          params: [
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        },
        {
          goodsType: 'adhesive',
          goodsFilter: {
            type: ['ORM'],
            family: ['Chemical'],
            category: ['Adhesive']
          },
          multiple: false,
          params: [
            {
              name: 'Input Quantity',
              type: 'quantity',
              value: 'quantity',
              disabled: false
            }
          ]
        }
      ]
    },
    outputs: {
      type: 'single',
      arguments: [
        {
          name: 'Output Quantity',
          type: 'label',
          value: _.get(processRow, 'quantity', ''),
          unit: 'KG',
          disabled: true
        }
      ]
    },
    tableHeaders: [
      {
        text: 'Nominal Speed',
        value: 'nominalSpeed'
      },
      {
        text: 'Planned Hours(s)',
        value: 'plannedHours'
      },
      {
        text: 'Linear Length',
        value: 'linearMeters'
      },
      {
        text: 'Expected Output Waste',
        value: 'wastePercentage'
      },
      {
        text: 'Expected Output Waste Weight',
        value: 'waste'
      },
      {
        text: 'Expected Output Net Weight',
        value: 'netWeight'
      }
    ]
  }
}

export function convert(process: FTProcess) : ConversionResults {
  const conversionResult : ConversionResults = {
    inputs: [],
    outputs: [],
    details: new ConversionDetails(),
  };

  initProcess(process);

  const frontRMFtProcessRow = process.inputs[0];
  const backRMFtProcessRow = process.inputs[1];
  const adhesiveFtProcessRow = process.inputs[2];
  let outputFTProcessRow = process.outputs[0];
  if(process.settings.doubleLamination) {
    const duplicateFrontRMFtProcessRow1 = new FTProcessRow({ ftProcessRow: frontRMFtProcessRow, ftProcess: process });
    duplicateFrontRMFtProcessRow1.quantity = frontRMFtProcessRow.quantity/2;
    const duplicateFrontRMFtProcessRow2 = new FTProcessRow({ ftProcessRow: frontRMFtProcessRow, ftProcess: process });
    duplicateFrontRMFtProcessRow2.quantity = frontRMFtProcessRow.quantity/2;
    const duplicateAdhesiveFtProcessRow1 = new FTProcessRow({ ftProcessRow: adhesiveFtProcessRow, ftProcess: process });
    duplicateAdhesiveFtProcessRow1.quantity = adhesiveFtProcessRow.quantity/2;
    const duplicateAdhesiveFtProcessRow2 = new FTProcessRow({ ftProcessRow: adhesiveFtProcessRow, ftProcess: process });
    duplicateAdhesiveFtProcessRow2.quantity = adhesiveFtProcessRow.quantity/2;
    const outputFTProcessRowAfterFirstLamination = convertStep.lamination(duplicateFrontRMFtProcessRow1, backRMFtProcessRow, duplicateAdhesiveFtProcessRow1);
    outputFTProcessRow = convertStep.lamination(outputFTProcessRowAfterFirstLamination, duplicateFrontRMFtProcessRow2, duplicateAdhesiveFtProcessRow2);
  } else {
    outputFTProcessRow = convertStep.lamination(frontRMFtProcessRow, backRMFtProcessRow, adhesiveFtProcessRow);
  }
  outputFTProcessRow.goodsObject.form = 'sheet';
  conversionResult.outputs[0] = outputFTProcessRow;
  if(outputFTProcessRow.goodsObject && outputFTProcessRow.goodsObject.dimensions) {
    conversionResult.details.linearMeters = weightToLength(outputFTProcessRow.quantity, outputFTProcessRow.goodsObject.density, outputFTProcessRow.goodsObject.dimensions.width);
  }
  conversionResult.details.wastePercentage = 0;
  conversionResult.details.waste = 0;
  conversionResult.details.netWeight = outputFTProcessRow.quantity;
  conversionResult.details.kgPerHour = 60 * process.machineDetail.mechanicalSpeed * (backRMFtProcessRow.dimensions.width / 1000) * outputFTProcessRow.goodsObject.density;
  conversionResult.details.plannedHours = outputFTProcessRow.quantity / conversionResult.details.kgPerHour;

  return conversionResult;
}